module.exports = __webpack_public_path__ + "img/device.c77c57ba.png";